import { render, staticRenderFns } from "./inquiry_detail.vue?vue&type=template&id=90499180&scoped=true"
import script from "./inquiry_detail.vue?vue&type=script&lang=js"
export * from "./inquiry_detail.vue?vue&type=script&lang=js"
import style0 from "./inquiry_detail.vue?vue&type=style&index=0&id=90499180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90499180",
  null
  
)

export default component.exports